import { render, staticRenderFns } from "./Expiration.vue?vue&type=template&id=70e7f548&"
import script from "./Expiration.vue?vue&type=script&lang=js&"
export * from "./Expiration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports